import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

const initialState = {
  currentDate: moment().format('YYYY-MM-DD')
};

export const InspectionStore = createSlice({
  name: 'inspection',
  initialState,
  reducers: {
    changeCurrentDate: (state, action) => {
      state.currentDate = action.payload;
    }
  }
});

export const { changeCurrentDate } = InspectionStore.actions;

export default InspectionStore.reducer;
